var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000149395 1.62935C0.000149395 1.05143 0.468573 0.583008 1.04649 0.583008H14.042C14.4306 0.583008 14.8031 0.737302 15.0778 1.01201L18.4052 4.33932C18.6799 4.61405 18.8342 4.98656 18.8342 5.37516V18.3707C18.8342 18.9486 18.3657 19.417 17.7878 19.417H15.0673V11.0463C15.0673 10.4684 14.5989 9.99998 14.021 9.99998H4.81319C4.23528 9.99998 3.76686 10.4684 3.76686 11.0463V19.417H1.04634C0.468423 19.417 0 18.9486 0 18.3707L0.000149395 1.62935ZM5.96428 12.0927C5.67525 12.0927 5.44111 12.327 5.44111 12.6159C5.44111 12.9048 5.67525 13.1391 5.96428 13.1391H12.8701C13.1591 13.1391 13.3933 12.9048 13.3933 12.6159C13.3933 12.327 13.1591 12.0927 12.8701 12.0927H5.96428ZM5.44111 14.7086C5.44111 14.4197 5.67525 14.1854 5.96428 14.1854H12.8701C13.1591 14.1854 13.3933 14.4197 13.3933 14.7086C13.3933 14.9975 13.1591 15.2317 12.8701 15.2317H5.96428C5.67525 15.2317 5.44111 14.9975 5.44111 14.7086ZM5.96428 16.2781C5.67525 16.2781 5.44111 16.5124 5.44111 16.8013C5.44111 17.0901 5.67525 17.3244 5.96428 17.3244H12.8701C13.1591 17.3244 13.3933 17.0901 13.3933 16.8013C13.3933 16.5124 13.1591 16.2781 12.8701 16.2781H5.96428Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.4c4513636a1cdf26c870cee6396c3cb8.svg";
export { ForwardRef as ReactComponent };